import { LOCAL_STORAGE_SUPER_ADMIN_KEY } from "../utils/network";
import axios from "axios";
import { PubDetail } from "./cafe";

export async function getPubList(): Promise<PubDetail[]> {
  const token = localStorage.getItem(LOCAL_STORAGE_SUPER_ADMIN_KEY);
  const res = await axios.get(
    `${process.env.REACT_APP_WEB_API_HOST}/admin/pub/franchise-list`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
  return res.data;
}

export async function getSellerToken(pubId: number) {
  const token = localStorage.getItem(LOCAL_STORAGE_SUPER_ADMIN_KEY);
  const res = await axios.get(
    `${process.env.REACT_APP_WEB_API_HOST}/seller/pub/seller-token/${pubId}`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
  return res.data;
}
